import axios from 'axios';
import handleError from '../../../../../../../../../../../components/FormHelpers/handleError';
import Auth0 from '../../../../../../../../../../../store/actions/auth/Auth';
import { actionCreators } from '../../../../../../../../../data/upload/actions';

const submitForm = (values, dispatch, uploadData) => {
  return axios.patch(`/api/admin/deliveries/fromCustomer/${uploadData.id}`, {
    ...uploadData,
    ...values,
    status: 'Approved'
  }, { headers: { "Authorization": `Bearer ${Auth0.getAccessToken()}` } })
  .then((response) => {
    dispatch(actionCreators.setSingleUploadData(response.data));
  })
  .catch((err) => handleError(err.response));
};

export default submitForm;
